<div class="w-40">
  <app-model-field-number
    [id]="'attribute-numeric-' + testIdKey()"
    [value]="score() ?? null"
    (valueChange)="onValueChange($event)"
    [isReadOnly]="disabled()"
    mode="integer"
    [placeholder]="'provider.tenderResponse.subcriteriaAttributes.enterNumericValue' | transloco"
  />
</div>
